import { Button } from "@/components/ui"

/**
 * Leerer Zustand mit Erklärung + Handlungsaufforderung (UX_KONZEPT.md §4
 * Punkt 2) statt nur „Keine Einträge".
 */
export function EmptyState({
  text,
  aktion,
}: {
  text: string
  aktion?: { label: string; onClick: () => void }
}) {
  return (
    <div className="flex flex-col items-center gap-3 py-10 text-center">
      <p className="text-sm text-slate-500">{text}</p>
      {aktion && (
        <Button type="button" onClick={aktion.onClick}>
          {aktion.label}
        </Button>
      )}
    </div>
  )
}
